import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Eyebrow, Button, HUDBrackets } from './UI';
import { trackAddToCart } from '../lib/pixel';
import { Truck, Shield, RefreshCw, Lock, ChevronDown, Check, Plus, Minus, Flame, Snowflake, Users, User, Star, Send, Zap, Crosshair, Ghost } from 'lucide-react';
const lensAddons = [{
  id: 'ice',
  name: 'ICE MIRROR LENS',
  sub: 'Blue / Purple Iridium',
  desc: 'Cold-spectrum mirror. High-altitude UV reduction.',
  price: 4.95,
  icon: <Snowflake size={18} data-id="element-1231" data-mp="1f8g2zdx0pvg4" />,
  gradient: 'linear-gradient(135deg, #b266ff 0%, #2a6dff 50%, #00c2ff 100%)',
  previewSrc: 'https://cdn.magicpatterns.com/uploads/i83EYvoLKtLaCwpLHgESRH/hf_20260506_130002_0d9ba6fa-3e05-4389-bd70-b9ee2bcc91e4.png',
  previewLabel: 'ICE LENS EQUIPPED'
}];
const specs = [{
  label: 'Shell',
  value: 'Glass-Fiber Reinforced Composite'
}, {
  label: 'Frame',
  value: 'Grade 304 Stainless Steel'
}, {
  label: 'Lens',
  value: 'Lexan Polycarbonate — ANSI Z87.1'
}, {
  label: 'Coating',
  value: 'Anti-Fog Nano + UV400'
}, {
  label: 'Strap',
  value: 'Ballistic Nylon — Dual Adjust'
}, {
  label: 'Weight',
  value: '380g (13.4 oz)'
}, {
  label: 'Fit',
  value: 'Universal — 52cm–62cm'
}, {
  label: 'Ventilation',
  value: '14-Port Dual Mesh'
}];
const gallery = [{
  src: 'https://cdn.magicpatterns.com/uploads/ccNoC1hUfPputXVXttp9ur/hf_20260505_164053_a2220f21-6ee4-4e03-a216-305128115bb2.png',
  alt: 'Mask Field Deployed',
  label: 'FIELD DEPLOYED'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/8wsq1CLQoFFHFK7Ud539GB/hf_20260505_161401_b22ab001-c648-4408-a098-97bb18fba3a3.png',
  alt: 'BLACKOUT UNIT Box',
  label: 'PACKAGING'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ixvSzA9vgFfVZNTHmoz2hu/hf_20260505_160349_8ac9e7f0-517f-4f74-9ee5-49caa262d662.png',
  alt: 'Mask Front',
  label: 'FRONT VIEW'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/wktPfPj4sasfKV5cbuidEQ/hf_20260505_160726_c7d8c9e1-4986-4b8e-9be1-eab15717a38a.png',
  alt: 'Mask Side',
  label: 'SIDE PROFILE'
}];
const bundles = [{
  id: 'duo',
  name: 'DUO STRIKE',
  count: 2,
  price: 39.9,
  badge: 'MOST POPULAR',
  desc: 'Add your 2nd mask for just $9.95',
  cartUrl: 'https://blackoutunit.com/cart/44424057225309:1'
}, {
  id: 'squad',
  name: 'SQUAD UNIT',
  count: 4,
  price: 89.95,
  badge: 'BEST VALUE',
  cartUrl: 'https://blackoutunit.com/cart/44427736711261:1'
}, {
  id: 'platoon',
  name: 'PLATOON SIX',
  count: 6,
  price: 128.95,
  badge: null,
  cartUrl: 'https://blackoutunit.com/cart/44427736842333:1'
}, {
  id: 'battalion',
  name: 'BATTALION EIGHT',
  count: 8,
  price: 169.95,
  badge: null,
  cartUrl: 'https://blackoutunit.com/cart/44483132620893:1'
}];
const BASE_PRICE = 29.95;
const COMPARE_PRICE = 69.98;
const SINGLE_MASK_URL = 'https://blackoutunit.com/cart/44483157852253:1';
const DUO_MASK_URL = 'https://blackoutunit.com/cart/44424057225309:1';
const TRIPLE_MASK_URL = 'https://blackoutunit.com/cart/44443902738525:1';
const QUAD_MASK_URL = 'https://blackoutunit.com/cart/44427736711261:1';
const SIX_MASK_URL = 'https://blackoutunit.com/cart/44427736842333:1';
const EIGHT_MASK_URL = 'https://blackoutunit.com/cart/44483132620893:1';
// Single mask + 1 fire mirror lens
const ONE_BLACK_ONE_FIRE_URL = 'https://blackoutunit.com/cart/44424057389149:1';
// Single mask + 1 ice mirror lens
const ONE_BLACK_ONE_ICE_URL = 'https://blackoutunit.com/cart/44483158311005:1';
// Single mask + 1 fire + 1 ice (same SKU as TRI-COLOR SQUAD)
const ONE_BLACK_FIRE_AND_ICE_URL = 'https://blackoutunit.com/cart/44425874407517:1';
// Two masks + 1 fire lens
const TWO_BLACK_ONE_FIRE_URL = 'https://blackoutunit.com/cart/44444222849117:1';
// Two masks + 1 ice lens
const TWO_BLACK_ONE_ICE_URL = 'https://blackoutunit.com/cart/44483141337181:1';
// Two masks + 2 ice lenses
const TWO_BLACK_TWO_ICE_URL = 'https://blackoutunit.com/cart/44483141664861:1';
// Four masks + 1 ice lens (and SQUAD UNIT bundle + 1 ice lens)
const FOUR_BLACK_ONE_ICE_URL = 'https://blackoutunit.com/cart/44483159326813:1';
// Four masks + 2 ice lenses (and SQUAD UNIT bundle + 2 ice lenses)
const FOUR_BLACK_TWO_ICE_URL = 'https://blackoutunit.com/cart/44483159752797:1';
// Four masks + 3 ice lenses (and SQUAD UNIT bundle + 3 ice lenses)
const FOUR_BLACK_THREE_ICE_URL = 'https://blackoutunit.com/cart/44483162177629:1';
// Four masks + 4 ice lenses (and SQUAD UNIT bundle + 4 ice lenses)
const FOUR_BLACK_FOUR_ICE_URL = 'https://blackoutunit.com/cart/44483162800221:1';
// Six masks + 1 ice lens (and PLATOON SIX bundle + 1 ice lens)
const SIX_BLACK_ONE_ICE_URL = 'https://blackoutunit.com/cart/44483164405853:1';
// Six masks + 2 ice lenses (and PLATOON SIX bundle + 2 ice lenses)
const SIX_BLACK_TWO_ICE_URL = 'https://blackoutunit.com/cart/44483165454429:1';
// Six masks + 3 ice lenses (and PLATOON SIX bundle + 3 ice lenses)
const SIX_BLACK_THREE_ICE_URL = 'https://blackoutunit.com/cart/44483165618269:1';
// Six masks + 4 ice lenses (and PLATOON SIX bundle + 4 ice lenses)
const SIX_BLACK_FOUR_ICE_URL = 'https://blackoutunit.com/cart/44483166011485:1';
// Six masks + 5 ice lenses (and PLATOON SIX bundle + 5 ice lenses)
const SIX_BLACK_FIVE_ICE_URL = 'https://blackoutunit.com/cart/44483166732381:1';
// Six masks + 6 ice lenses (and PLATOON SIX bundle + 6 ice lenses)
const SIX_BLACK_SIX_ICE_URL = 'https://blackoutunit.com/cart/44483166863453:1';
// Eight masks + 1 ice lens (and BATTALION EIGHT bundle + 1 ice lens)
const EIGHT_BLACK_ONE_ICE_URL = 'https://blackoutunit.com/cart/44483167060061:1';
// Eight masks + 2 ice lenses (and BATTALION EIGHT bundle + 2 ice lenses)
const EIGHT_BLACK_TWO_ICE_URL = 'https://blackoutunit.com/cart/44483167158365:1';
// Eight masks + 3 ice lenses (and BATTALION EIGHT bundle + 3 ice lenses)
const EIGHT_BLACK_THREE_ICE_URL = 'https://blackoutunit.com/cart/44483167453277:1';
// Eight masks + 4 ice lenses (and BATTALION EIGHT bundle + 4 ice lenses)
const EIGHT_BLACK_FOUR_ICE_URL = 'https://blackoutunit.com/cart/44483167649885:1';
// Eight masks + 5 ice lenses (and BATTALION EIGHT bundle + 5 ice lenses)
const EIGHT_BLACK_FIVE_ICE_URL = 'https://blackoutunit.com/cart/44483167977565:1';
// Eight masks + 6 ice lenses (and BATTALION EIGHT bundle + 6 ice lenses)
const EIGHT_BLACK_SIX_ICE_URL = 'https://blackoutunit.com/cart/44483168501853:1';
// Eight masks + 7 ice lenses (and BATTALION EIGHT bundle + 7 ice lenses)
const EIGHT_BLACK_SEVEN_ICE_URL = 'https://blackoutunit.com/cart/44483171188829:1';
// Eight masks + 8 ice lenses (and BATTALION EIGHT bundle + 8 ice lenses)
const EIGHT_BLACK_EIGHT_ICE_URL = 'https://blackoutunit.com/cart/44483171811421:1';
// Two masks + 1 fire + 1 ice
const TWO_BLACK_FIRE_AND_ICE_URL = 'https://blackoutunit.com/cart/44444225339485:1';
// DUO STRIKE bundle + 1 fire lens
const DUO_BUNDLE_ONE_FIRE_URL = 'https://blackoutunit.com/cart/44444241461341:1';
// DUO STRIKE bundle + 1 ice lens
const DUO_BUNDLE_ONE_ICE_URL = 'https://blackoutunit.com/cart/44483141337181:1';
// Resolves the correct Shopify cart URL based on current selection.
// Returns null if no URL is configured for the combination yet.
const resolveCartUrl = (activeBundle: {
  id: string;
  cartUrl: string | null;
} | null, qty: number, addonQty: Record<string, number>): string | null => {
  const fireQty = addonQty.fire ?? 0;
  const iceQty = addonQty.ice ?? 0;
  const totalAddons = fireQty + iceQty;
  // Bundle selected
  if (activeBundle) {
    // Bundle + add-on combinations
    if (totalAddons > 0) {
      // DUO STRIKE + 1 fire lens
      if (activeBundle.id === 'duo' && fireQty === 1 && iceQty === 0) {
        return DUO_BUNDLE_ONE_FIRE_URL;
      }
      // DUO STRIKE + 1 ice lens
      if (activeBundle.id === 'duo' && iceQty === 1 && fireQty === 0) {
        return DUO_BUNDLE_ONE_ICE_URL;
      }
      // DUO STRIKE + 2 ice lenses
      if (activeBundle.id === 'duo' && iceQty === 2 && fireQty === 0) {
        return TWO_BLACK_TWO_ICE_URL;
      }
      // SQUAD UNIT (4 masks) + 1 ice lens
      if (activeBundle.id === 'squad' && iceQty === 1 && fireQty === 0) {
        return FOUR_BLACK_ONE_ICE_URL;
      }
      // SQUAD UNIT (4 masks) + 2 ice lenses
      if (activeBundle.id === 'squad' && iceQty === 2 && fireQty === 0) {
        return FOUR_BLACK_TWO_ICE_URL;
      }
      // SQUAD UNIT (4 masks) + 3 ice lenses
      if (activeBundle.id === 'squad' && iceQty === 3 && fireQty === 0) {
        return FOUR_BLACK_THREE_ICE_URL;
      }
      // SQUAD UNIT (4 masks) + 4 ice lenses
      if (activeBundle.id === 'squad' && iceQty === 4 && fireQty === 0) {
        return FOUR_BLACK_FOUR_ICE_URL;
      }
      // PLATOON SIX (6 masks) + 1 ice lens
      if (activeBundle.id === 'platoon' && iceQty === 1 && fireQty === 0) {
        return SIX_BLACK_ONE_ICE_URL;
      }
      // PLATOON SIX (6 masks) + 2 ice lenses
      if (activeBundle.id === 'platoon' && iceQty === 2 && fireQty === 0) {
        return SIX_BLACK_TWO_ICE_URL;
      }
      // PLATOON SIX (6 masks) + 3 ice lenses
      if (activeBundle.id === 'platoon' && iceQty === 3 && fireQty === 0) {
        return SIX_BLACK_THREE_ICE_URL;
      }
      // PLATOON SIX (6 masks) + 4 ice lenses
      if (activeBundle.id === 'platoon' && iceQty === 4 && fireQty === 0) {
        return SIX_BLACK_FOUR_ICE_URL;
      }
      // PLATOON SIX (6 masks) + 5 ice lenses
      if (activeBundle.id === 'platoon' && iceQty === 5 && fireQty === 0) {
        return SIX_BLACK_FIVE_ICE_URL;
      }
      // PLATOON SIX (6 masks) + 6 ice lenses
      if (activeBundle.id === 'platoon' && iceQty === 6 && fireQty === 0) {
        return SIX_BLACK_SIX_ICE_URL;
      }
      // BATTALION EIGHT (8 masks) + 1 ice lens
      if (activeBundle.id === 'battalion' && iceQty === 1 && fireQty === 0) {
        return EIGHT_BLACK_ONE_ICE_URL;
      }
      // BATTALION EIGHT (8 masks) + 2 ice lenses
      if (activeBundle.id === 'battalion' && iceQty === 2 && fireQty === 0) {
        return EIGHT_BLACK_TWO_ICE_URL;
      }
      // BATTALION EIGHT (8 masks) + 3 ice lenses
      if (activeBundle.id === 'battalion' && iceQty === 3 && fireQty === 0) {
        return EIGHT_BLACK_THREE_ICE_URL;
      }
      // BATTALION EIGHT (8 masks) + 4 ice lenses
      if (activeBundle.id === 'battalion' && iceQty === 4 && fireQty === 0) {
        return EIGHT_BLACK_FOUR_ICE_URL;
      }
      // BATTALION EIGHT (8 masks) + 5 ice lenses
      if (activeBundle.id === 'battalion' && iceQty === 5 && fireQty === 0) {
        return EIGHT_BLACK_FIVE_ICE_URL;
      }
      // BATTALION EIGHT (8 masks) + 6 ice lenses
      if (activeBundle.id === 'battalion' && iceQty === 6 && fireQty === 0) {
        return EIGHT_BLACK_SIX_ICE_URL;
      }
      // BATTALION EIGHT (8 masks) + 7 ice lenses
      if (activeBundle.id === 'battalion' && iceQty === 7 && fireQty === 0) {
        return EIGHT_BLACK_SEVEN_ICE_URL;
      }
      // BATTALION EIGHT (8 masks) + 8 ice lenses
      if (activeBundle.id === 'battalion' && iceQty === 8 && fireQty === 0) {
        return EIGHT_BLACK_EIGHT_ICE_URL;
      }
      // Other bundle + addon combinations pending
      return null;
    }
    return activeBundle.cartUrl;
  }
  // Combinations with add-ons
  if (totalAddons > 0) {
    // 1 black mask + 1 fire mirror lens (no ice)
    if (qty === 1 && fireQty === 1 && iceQty === 0) {
      return ONE_BLACK_ONE_FIRE_URL;
    }
    // 1 black mask + 1 ice mirror lens (no fire)
    if (qty === 1 && iceQty === 1 && fireQty === 0) {
      return ONE_BLACK_ONE_ICE_URL;
    }
    // 2 black masks + 1 fire lens
    if (qty === 2 && fireQty === 1 && iceQty === 0) {
      return TWO_BLACK_ONE_FIRE_URL;
    }
    // 2 black masks + 1 ice lens
    if (qty === 2 && iceQty === 1 && fireQty === 0) {
      return TWO_BLACK_ONE_ICE_URL;
    }
    // 2 black masks + 2 ice lenses
    if (qty === 2 && iceQty === 2 && fireQty === 0) {
      return TWO_BLACK_TWO_ICE_URL;
    }
    // 2 black masks + 1 fire + 1 ice (legacy combo)
    if (qty === 2 && fireQty === 1 && iceQty === 1) {
      return TWO_BLACK_FIRE_AND_ICE_URL;
    }
    // 4 black masks + 1 ice lens
    if (qty === 4 && iceQty === 1 && fireQty === 0) {
      return FOUR_BLACK_ONE_ICE_URL;
    }
    // 4 black masks + 2 ice lenses
    if (qty === 4 && iceQty === 2 && fireQty === 0) {
      return FOUR_BLACK_TWO_ICE_URL;
    }
    // 4 black masks + 3 ice lenses
    if (qty === 4 && iceQty === 3 && fireQty === 0) {
      return FOUR_BLACK_THREE_ICE_URL;
    }
    // 4 black masks + 4 ice lenses
    if (qty === 4 && iceQty === 4 && fireQty === 0) {
      return FOUR_BLACK_FOUR_ICE_URL;
    }
    // 6 black masks + 1 ice lens
    if (qty === 6 && iceQty === 1 && fireQty === 0) {
      return SIX_BLACK_ONE_ICE_URL;
    }
    // 6 black masks + 2 ice lenses
    if (qty === 6 && iceQty === 2 && fireQty === 0) {
      return SIX_BLACK_TWO_ICE_URL;
    }
    // 6 black masks + 3 ice lenses
    if (qty === 6 && iceQty === 3 && fireQty === 0) {
      return SIX_BLACK_THREE_ICE_URL;
    }
    // 6 black masks + 4 ice lenses
    if (qty === 6 && iceQty === 4 && fireQty === 0) {
      return SIX_BLACK_FOUR_ICE_URL;
    }
    // 6 black masks + 5 ice lenses
    if (qty === 6 && iceQty === 5 && fireQty === 0) {
      return SIX_BLACK_FIVE_ICE_URL;
    }
    // 6 black masks + 6 ice lenses
    if (qty === 6 && iceQty === 6 && fireQty === 0) {
      return SIX_BLACK_SIX_ICE_URL;
    }
    // 8 black masks + 1 ice lens
    if (qty === 8 && iceQty === 1 && fireQty === 0) {
      return EIGHT_BLACK_ONE_ICE_URL;
    }
    // 8 black masks + 2 ice lenses
    if (qty === 8 && iceQty === 2 && fireQty === 0) {
      return EIGHT_BLACK_TWO_ICE_URL;
    }
    // 8 black masks + 3 ice lenses
    if (qty === 8 && iceQty === 3 && fireQty === 0) {
      return EIGHT_BLACK_THREE_ICE_URL;
    }
    // 8 black masks + 4 ice lenses
    if (qty === 8 && iceQty === 4 && fireQty === 0) {
      return EIGHT_BLACK_FOUR_ICE_URL;
    }
    // 8 black masks + 5 ice lenses
    if (qty === 8 && iceQty === 5 && fireQty === 0) {
      return EIGHT_BLACK_FIVE_ICE_URL;
    }
    // 8 black masks + 6 ice lenses
    if (qty === 8 && iceQty === 6 && fireQty === 0) {
      return EIGHT_BLACK_SIX_ICE_URL;
    }
    // 8 black masks + 7 ice lenses
    if (qty === 8 && iceQty === 7 && fireQty === 0) {
      return EIGHT_BLACK_SEVEN_ICE_URL;
    }
    // 8 black masks + 8 ice lenses
    if (qty === 8 && iceQty === 8 && fireQty === 0) {
      return EIGHT_BLACK_EIGHT_ICE_URL;
    }
    // Other addon combinations pending
    return null;
  }
  // Single mask
  if (qty === 1) return SINGLE_MASK_URL;
  // Two black masks → same destination as DUO STRIKE
  if (qty === 2) return DUO_MASK_URL;
  // Three black masks with black lenses
  if (qty === 3) return TRIPLE_MASK_URL;
  // Four black masks → same destination as SQUAD UNIT
  if (qty === 4) return QUAD_MASK_URL;
  // Six black masks → same destination as PLATOON SIX
  if (qty === 6) return SIX_MASK_URL;
  // Eight black masks → same destination as BATTALION EIGHT
  if (qty === 8) return EIGHT_MASK_URL;
  // Other quantities pending
  return null;
};
export const Product = () => {
  const [activeImage, setActiveImage] = useState(0);
  const [qty, setQty] = useState(1);
  const [addonQty, setAddonQty] = useState<Record<string, number>>({});
  const [selectedBundle, setSelectedBundle] = useState<string | null>(null);
  const [openAccordion, setOpenAccordion] = useState<string | null>('specs');
  const [lensPreviewId, setLensPreviewId] = useState<string | null>(null);
  const toggleAccordion = (id: string) => {
    setOpenAccordion(openAccordion === id ? null : id);
  };
  const getAddonQty = (id: string) => addonQty[id] ?? 0;
  const changeAddonQty = (id: string, delta: number) => {
    setAddonQty(prev => {
      const current = prev[id] ?? 0;
      const next = Math.max(0, current + delta);
      const updated = {
        ...prev,
        [id]: next
      };
      // When increasing from 0 → preview this lens
      const addon = lensAddons.find(a => a.id === id);
      if (current === 0 && next > 0 && addon?.previewSrc) {
        setLensPreviewId(id);
        if (typeof window !== 'undefined' && window.innerWidth < 1024) {
          const el = document.getElementById('the-mask');
          el?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
      // When dropping to 0 and it was the preview → clear preview
      if (next === 0 && lensPreviewId === id) {
        setLensPreviewId(null);
      }
      return updated;
    });
  };
  const toggleBundle = (id: string) => {
    setSelectedBundle(prev => prev === id ? null : id);
  };
  const activeBundle = bundles.find(b => b.id === selectedBundle) || null;
  const masksSubtotal = activeBundle ? activeBundle.price : BASE_PRICE * qty;
  const maskCount = activeBundle ? activeBundle.count : qty;
  const totalAddons = Object.values(addonQty).reduce((a, b) => a + b, 0);
  const addonsTotal = totalAddons * 4.95;
  const total = masksSubtotal + addonsTotal;
  const savings = (COMPARE_PRICE - BASE_PRICE).toFixed(2);
  const savingsPct = Math.round((COMPARE_PRICE - BASE_PRICE) / COMPARE_PRICE * 100);
  const cartUrl = resolveCartUrl(activeBundle, qty, addonQty);
  const handleDeploy = () => {
    if (cartUrl) {
      trackAddToCart({
        value: total,
        contents: {
          maskCount,
          addonQty,
          bundle: activeBundle?.id ?? null
        }
      });
      window.location.href = cartUrl;
    } else {
      alert('Lógica de carrito para esta combinación pendiente de links.');
    }
  };
  // Dispatch event to update sticky mobile bar
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('priceUpdate', {
        detail: {
          total,
          qty,
          activeBundle,
          addonQty,
          totalAddons,
          cartUrl
        }
      }));
    }
  }, [total, qty, activeBundle, addonQty, totalAddons, cartUrl]);
  return <section id="the-mask" className="bg-base-black pt-[40px] pb-[40px]" data-id="element-1232" data-mp="1dpxwjjxtacme">
      <div className="container mx-auto px-6 md:px-12" data-id="element-1233" data-mp="18sz5ja9g2lsf">
        <div className="text-center mb-16" data-id="element-1234" data-mp="18uac1hu9y7n8">
          <Eyebrow data-id="element-1235" data-mp="13tcqqwdywxhi">THE WEAPON</Eyebrow>
          <h2 className="text-5xl md:text-[72px] leading-[0.9] mb-4" data-id="element-1236" data-mp="13ue5pby3u44i">
            THE BLACKOUT UNIT{' '}
            <span className="text-acid-green" data-id="element-1237" data-mp="z09wem1d9k09">ULTIMATE MASK</span>
          </h2>
          <p className="font-barlow text-lg text-text-body" data-id="element-1238" data-mp="u3t7vqq993mn">
            Configure your unit. Deploy.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 xl:gap-16" data-id="element-1239" data-mp="pzv7lcp71ms0">
          {/* Left - Image Gallery (BIGGER) */}
          <div className="w-full" data-id="element-1240" data-mp="g2z0nbey18pk">
            <div className="lg:sticky lg:top-24" data-id="element-1241" data-mp="g40ko5dxt5jf">
              {/* Main Image */}
              {(() => {
              const previewAddon = lensPreviewId ? lensAddons.find(a => a.id === lensPreviewId) : null;
              const showPreview = !!(previewAddon && previewAddon.previewSrc);
              const displaySrc = showPreview ? previewAddon!.previewSrc as string : gallery[activeImage].src;
              const displayAlt = showPreview ? `Mask equipped with ${previewAddon!.name}` : gallery[activeImage].alt;
              const displayLabel = showPreview ? previewAddon!.previewLabel : gallery[activeImage].label;
              const displayKey = showPreview ? `lens-${lensPreviewId}` : `gallery-${activeImage}`;
              return <div className="relative border border-acid-green/20 bg-dark-1 mb-4 flex justify-center items-center aspect-[4/5] lg:aspect-square xl:aspect-[4/5] lg:max-h-[65vh] overflow-hidden" data-id="element-1242" data-mp="1ubge3we45slo">
                    <HUDBrackets data-id="element-1243" data-mp="16ouy1qul14dy" />
                    <div className="absolute top-4 left-4 flex flex-col items-start gap-2 z-10" data-id="element-1244" data-mp="16o227kx5vzal">
                      <div className="bg-halloween-orange text-black font-barlow font-bold text-[10px] tracking-[2px] px-3 py-1 flex items-center gap-1.5" data-id="element-1245" data-mp="1arro22mgc2rx">
                        <Ghost size={12} strokeWidth={2.5} data-id="element-1246" data-mp="izisr22dlggx" />
                        HALLOWEEN PICK — 60% OFF
                      </div>
                      <div className="bg-acid-green text-black font-barlow font-bold text-[10px] tracking-[2px] px-3 py-1" data-id="element-1247" data-mp="n25npbucfhic">
                        BESTSELLER UNIT
                      </div>
                    </div>
                    <div className="absolute top-4 right-4 font-barlow text-[10px] text-acid-green tracking-[2px] z-10 border border-acid-green/40 px-2 py-1 bg-base-black/60" data-id="element-1248" data-mp="wrp50d2er3b3">
                      {displayLabel}
                    </div>
                    <AnimatePresence mode="wait" data-id="element-1249" data-mp="489y2ejm94wx">
                      <motion.img key={displayKey} src={displaySrc} alt={displayAlt} initial={{
                    opacity: 0,
                    scale: 1.02
                  }} animate={{
                    opacity: 1,
                    scale: 1
                  }} exit={{
                    opacity: 0
                  }} transition={{
                    duration: 0.35
                  }} className="w-full h-full object-cover" data-id="element-1250" data-mp="3sv6iyrndb8nf" />
                    </AnimatePresence>
                    {showPreview && <button onClick={() => setLensPreviewId(null)} className="absolute bottom-4 right-4 z-20 font-barlow text-[10px] tracking-[2px] uppercase text-white bg-base-black/70 border border-acid-green/40 hover:border-acid-green hover:text-acid-green px-3 py-1 transition-colors" data-id="element-1251" data-mp="2r5udtkqjnop2">
                        ✕ Exit Preview
                      </button>}
                    <div className="absolute bottom-4 left-4 font-barlow text-[10px] text-text-dimmed tracking-[2px] z-10" data-id="element-1252" data-mp="27lcct35xp5oq">
                      {showPreview ? 'LENS PREVIEW' : `${String(activeImage + 1).padStart(2, '0')} / ${String(gallery.length).padStart(2, '0')}`}
                    </div>
                  </div>;
            })()}

              {/* Thumbnails */}
              <div className="grid grid-cols-4 gap-3" data-id="element-1253" data-mp="2qj6gd1oamozq">
                {gallery.map((img, i) => <button key={i} onClick={() => {
                setActiveImage(i);
                setLensPreviewId(null);
              }} className={`border-2 bg-dark-1 aspect-square overflow-hidden transition-all ${!lensPreviewId && activeImage === i ? 'border-acid-green' : 'border-dark-3 hover:border-white/40'}`} data-id="element-1254" data-mp="3e8rbeixq1cpd" data-mpi={i}>
                    <img src={img.src} alt={img.alt} className="w-full h-full object-cover" data-id="element-1255" data-mp="1gdc61dr8vcg4" />
                  </button>)}
              </div>
            </div>
          </div>

          {/* Right - Product Info & Configurator */}
          <div className="w-full flex flex-col" data-id="element-1256" data-mp="jpxr5l18nnk7">
            <div className="flex items-center gap-3 font-barlow text-sm tracking-wider mb-4 flex-wrap" data-id="element-1257" data-mp="xof72wkwjvrk">
              <div className="flex items-center gap-0.5 text-acid-green" data-id="element-1258" data-mp="snhtkxau7pwe">
                {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="currentColor" strokeWidth={0} data-id="element-1259" data-mp="290oiuw7ls5w8" data-mpi={i} />)}
              </div>
              <div className="text-white" data-id="element-1260" data-mp="245skzffoqob7">4.9 / 5.0</div>
              <div className="text-text-dimmed" data-id="element-1261" data-mp="2zewgvpv11641">|</div>
              <div className="text-text-dimmed" data-id="element-1262" data-mp="34cfviqvmzkwi">(9,273 verified)</div>
              <div className="text-text-dimmed" data-id="element-1263" data-mp="34esacv63lf5c">|</div>
              <div className="text-acid-green flex items-center" data-id="element-1264" data-mp="39bize7zvrl2w">
                <span className="w-2 h-2 bg-acid-green rounded-full mr-2" data-id="element-1265" data-mp="3eavoz0i4z696"></span>
                IN STOCK
              </div>
            </div>

            <h1 className="font-bebas text-[44px] md:text-[52px] leading-none mb-2" data-id="element-1266" data-mp="3ibfhfqrrlloz">
              BLACKOUT UNIT ULTIMATE MASK™
            </h1>
            <p className="font-barlow text-lg text-text-dimmed mb-6" data-id="element-1267" data-mp="3n97cuurmbpxx">
              Full-Face Tactical Protection System
              <br data-id="element-1268" data-mp="vpi3qxq65ks" />
              Glass-Fiber Composite | Includes Smoke Black Lenses
            </p>

            {/* Halloween promo strip — limited-time offer layer */}
            <div className="flex items-center gap-3 border border-halloween-orange-border bg-halloween-orange-dim px-3 py-2 mb-5" data-id="element-1269" data-mp="5t8yawdzgsfd">
              <Ghost size={16} className="text-halloween-orange shrink-0" strokeWidth={2} data-id="element-1270" data-mp="1uf7pf8s0vg2u" />
              <span className="font-barlow font-bold text-[11px] text-halloween-orange tracking-[2px] uppercase leading-tight" data-id="element-1271" data-mp="1qbtbcnnn99s1">
                Halloween Sale — 60% off + free shipping. Limited stock.
              </span>
            </div>

            <div className="flex items-end gap-4 mb-2 pt-2" data-id="element-1272" data-mp="2e2fdxzevq1un">
              <div className="font-bebas text-[56px] text-white leading-none" data-id="element-1273" data-mp="2e4rv4actc86n">
                ${BASE_PRICE.toFixed(2)}
              </div>
              <div className="font-bebas text-3xl text-text-dimmed line-through leading-none mb-1" data-id="element-1274" data-mp="24cccrbxlthl8">
                ${COMPARE_PRICE.toFixed(2)}
              </div>
              <div className="bg-acid-green text-black font-barlow font-bold text-xs tracking-[2px] px-2 py-1 mb-2" data-id="element-1275" data-mp="1zbolqq9dl0r0">
                SAVE {savingsPct}%
              </div>
            </div>
            <p className="font-inter text-xs text-text-dimmed mb-8 pb-8 border-b border-dark-3" data-id="element-1276" data-mp="2s15andxsdzih">
              You save <span className="text-acid-green" data-id="element-1277" data-mp="q70tulpu0rs8">${savings}</span> per
              unit. Free shipping on all USA orders.
            </p>

            {/* Quantity (now at TOP) */}
            <div className="mb-8" data-id="element-1278" data-mp="gelc9pig657v">
              <div className="font-barlow text-xs text-text-dimmed tracking-widest uppercase mb-3" data-id="element-1279" data-mp="le7pw026tnh7">
                ━━ MASK QUANTITY ━━
              </div>
              <div className="flex items-center gap-4" data-id="element-1280" data-mp="6fdpkbptoy83">
                <div className="flex items-center border border-dark-3" data-id="element-1281" data-mp="bfrwfqfou24j">
                  <button onClick={() => setQty(Math.max(1, qty - 1))} className="px-4 py-3 text-text-dimmed hover:text-acid-green transition-colors" aria-label="Decrease quantity" data-id="element-1282" data-mp="bdnmorv3y8wc">
                    <Minus size={16} data-id="element-1283" data-mp="1rvl3siwz0g0u" />
                  </button>
                  <div className="w-14 text-center font-bebas text-2xl" data-id="element-1284" data-mp="1wtwf6y2wyyl6">
                    {qty}
                  </div>
                  <button onClick={() => setQty(qty + 1)} className="px-4 py-3 text-text-dimmed hover:text-acid-green transition-colors" aria-label="Increase quantity" data-id="element-1285" data-mp="26ycsbjp0e1la">
                    <Plus size={16} data-id="element-1286" data-mp="2frg5rrznmefx" />
                  </button>
                </div>
                <p className="font-inter text-xs text-text-dimmed" data-id="element-1287" data-mp="2awsbfchyyptf">
                  Each unit ships with{' '}
                  <span className="text-white font-bold" data-id="element-1288" data-mp="2ppm4y1u2t6h3">
                    smoke black lenses
                  </span>{' '}
                  standard.
                </p>
              </div>
            </div>

            {/* Lens Add-Ons / Order Bumps */}
            <div className="mb-8" data-id="element-1289" data-mp="2uo74dz1i7m4h">
              <div className="flex items-center gap-3 mb-2" data-id="element-1290" data-mp="2ul1fokwsem9a">
                <div className="font-barlow text-xs text-acid-green tracking-widest uppercase" data-id="element-1291" data-mp="14b7xd9xjk8wc">
                  ━━ POWER UP — OPTIONAL LENS ADD-ONS ━━
                </div>
              </div>
              <p className="font-inter text-[12px] text-text-dimmed mb-4" data-id="element-1292" data-mp="1ot00sgsrl9v2">
                Add a swappable mirrored lens to your order. Tool-free swap in
                under 30 seconds.
              </p>

              <div className="space-y-3" data-id="element-1293" data-mp="1ykw2s2xz1k4k">
                {lensAddons.map(addon => {
                const count = getAddonQty(addon.id);
                const active = count > 0;
                return <div key={addon.id} className={`w-full flex items-center gap-4 p-4 border text-left transition-all ${active ? 'border-acid-green bg-acid-green-dim' : 'border-dark-3 bg-dark-1'}`} data-id="element-1294" data-mp="15wrrn1wmseuh">
                      {/* Lens visual — click to preview */}
                      <button type="button" onClick={() => {
                    if (addon.previewSrc) {
                      setLensPreviewId(lensPreviewId === addon.id ? null : addon.id);
                    }
                  }} className="w-14 h-14 shrink-0 border-2 border-black/40 relative group/lens" style={{
                    background: addon.gradient,
                    boxShadow: 'inset 0 0 12px rgba(0,0,0,0.4)'
                  }} aria-label={`Preview ${addon.name}`} data-id="element-1295" data-mp="2qasdsjothjzc">
                        <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover/lens:opacity-100 transition-opacity bg-black/40 font-barlow text-[8px] tracking-[1px] text-white uppercase" data-id="element-1296" data-mp="2hn68boepmwmk">
                          Preview
                        </span>
                      </button>
                      {/* Body */}
                      <div className="flex-grow min-w-0" data-id="element-1297" data-mp="avf72eki738b">
                        <div className="flex items-center gap-2 mb-1" data-id="element-1298" data-mp="6xhgp8ezyb3c">
                          <span className="text-acid-green" data-id="element-1299" data-mp="w82ktcu2n8v1">{addon.icon}</span>
                          <h4 className="font-bebas text-[20px] text-white leading-none" data-id="element-1300" data-mp="s6z5crfxreuc">
                            {addon.name}
                          </h4>
                        </div>
                        <div className="font-barlow text-[10px] text-acid-green tracking-[1.5px] mb-1" data-id="element-1301" data-mp="10zari140og4i">
                          {addon.sub} · +${addon.price} each
                        </div>
                        <p className="font-inter text-[12px] text-text-dimmed leading-snug" data-id="element-1302" data-mp="dbjdmt2tvv14">
                          {addon.desc}
                        </p>
                      </div>
                      {/* Quantity stepper */}
                      <div className="flex flex-col items-end gap-2 shrink-0" data-id="element-1303" data-mp="i8jm1an5h9ve">
                        <div className="font-bebas text-[22px] text-white leading-none" data-id="element-1304" data-mp="1ymsxx5a7h65c">
                          {count > 0 ? `+${(count * addon.price).toFixed(2)}` : `+${addon.price}`}
                        </div>
                        <div className={`flex items-center border ${active ? 'border-acid-green' : 'border-dark-3'}`} data-id="element-1305" data-mp="3bnphj5jfjwrr">
                          <button type="button" onClick={() => changeAddonQty(addon.id, -1)} disabled={count === 0} className="px-2 py-1 text-text-dimmed hover:text-acid-green disabled:opacity-40 disabled:hover:text-text-dimmed transition-colors" aria-label={`Decrease ${addon.name} quantity`} data-id="element-1306" data-mp="32m7zviqdjn0y">
                            <Minus size={14} data-id="element-1307" data-mp="3qic3a55ekv3w" />
                          </button>
                          <div className={`w-8 text-center font-bebas text-[18px] leading-none ${active ? 'text-acid-green' : 'text-white'}`} data-id="element-1308" data-mp="i328li3ues65">
                            {count}
                          </div>
                          <button type="button" onClick={() => changeAddonQty(addon.id, 1)} className="px-2 py-1 text-text-dimmed hover:text-acid-green transition-colors" aria-label={`Increase ${addon.name} quantity`} data-id="element-1309" data-mp="wozj4rz065v8">
                            <Plus size={14} data-id="element-1310" data-mp="dr51jpjt6m18" />
                          </button>
                        </div>
                      </div>
                    </div>;
              })}
              </div>
            </div>

            {/* Multi-Pack Bundles */}
            <div className="mb-8" data-id="element-1311" data-mp="3v7emph6mdaoq">
              <div className="flex items-center gap-3 mb-2" data-id="element-1312" data-mp="3v8fxdkjq3v5x">
                <div className="font-barlow text-xs text-acid-green tracking-widest uppercase" data-id="element-1313" data-mp="3q8aa0gkhkutn">
                  ━━ MULTI-PACK BUNDLES — STOCK UP ━━
                </div>
              </div>
              <p className="font-inter text-[12px] text-text-dimmed mb-4" data-id="element-1314" data-mp="3m92nwrvln6l7">
                Equip your squad. Bundle pricing replaces single-mask quantity
                above.
              </p>

              <div className="space-y-3" data-id="element-1315" data-mp="25s3xhdo9yhvx">
                {bundles.map(bundle => {
                const checked = selectedBundle === bundle.id;
                const perUnit = (bundle.price / bundle.count).toFixed(2);
                const bundleSavings = (BASE_PRICE * bundle.count - bundle.price).toFixed(2);
                return <button key={bundle.id} onClick={() => toggleBundle(bundle.id)} className={`w-full flex items-center gap-4 p-4 border text-left transition-all relative ${checked ? 'border-acid-green bg-acid-green-dim' : 'border-dark-3 bg-dark-1 hover:border-acid-green/40'}`} data-id="element-1316" data-mp="1ryurlmzjcei5">
                      {bundle.badge && <div className="absolute -top-2 right-4 bg-acid-green text-black font-barlow font-bold text-[9px] tracking-[2px] px-2 py-0.5" data-id="element-1317" data-mp="35y66flyfp9te">
                          {bundle.badge}
                        </div>}
                      {/* Mask count visual */}
                      <div className={`w-14 h-14 shrink-0 border-2 flex items-center justify-center font-bebas text-[24px] ${checked ? 'border-acid-green text-acid-green' : 'border-dark-3 text-white'}`} data-id="element-1318" data-mp="3axsnk6hdva7h">
                        {bundle.count}×
                      </div>
                      {/* Body */}
                      <div className="flex-grow min-w-0" data-id="element-1319" data-mp="2h7b2fpjlyzm">
                        <div className="flex items-center gap-2 mb-1.5" data-id="element-1320" data-mp="3tniiqup25xzx">
                          {/* Dynamic head icons matching bundle.count */}
                          <div className="flex items-center -space-x-1" data-id="element-1321" data-mp="249c8u7tq3qi9">
                            {[...Array(bundle.count)].map((_, idx) => <User key={idx} size={12} strokeWidth={2.5} fill="currentColor" className="text-acid-green" data-id="element-1322" data-mp="erghde764fr6" data-mpi={idx} />)}
                          </div>
                          <h4 className="font-bebas text-[20px] text-white leading-none" data-id="element-1323" data-mp="3s6uuhwt75nhs">
                            {bundle.name}
                          </h4>
                        </div>
                        <div className="font-barlow text-[11px] text-text-dimmed tracking-[1px] mb-0.5" data-id="element-1324" data-mp="y7b3meioacv">
                          {bundle.count} MASKS · ${perUnit} EACH · SAVE $
                          {bundleSavings}
                        </div>
                        {bundle.desc && <div className="font-inter text-[10px] text-acid-green/80" data-id="element-1325" data-mp="1hcz2px3u9dl4">
                            {bundle.desc}
                          </div>}
                      </div>
                      {/* Price + checkbox */}
                      <div className="flex flex-col items-end gap-2 shrink-0" data-id="element-1326" data-mp="2pdhae48cca48">
                        <div className="font-bebas text-[22px] text-white leading-none" data-id="element-1327" data-mp="2lbvqw01awxl2">
                          ${bundle.price.toFixed(2)}
                        </div>
                        <div className={`w-6 h-6 border-2 flex items-center justify-center transition-colors ${checked ? 'border-acid-green bg-acid-green' : 'border-dark-3'}`} data-id="element-1328" data-mp="3d3tpq05x194u">
                          {checked && <Check size={14} className="text-black" strokeWidth={3} data-id="element-1329" data-mp="349owja3b7lm5" />}
                        </div>
                      </div>
                    </button>;
              })}
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col gap-4 mb-10" data-id="element-1330" data-mp="397c4jhl8bi6">
              <Button variant="primary" fullWidth onClick={handleDeploy} data-id="element-1331" data-mp="870jvgyjhdkk">
                <span className="inline-flex items-center justify-center gap-2" data-id="element-1332" data-mp="d4irn40tlmqz">
                  <Crosshair size={16} strokeWidth={2.5} data-id="element-1333" data-mp="h6ngzqk8jx7t" />
                  SHOP NOW — ${total.toFixed(2)}
                </span>
              </Button>
              <Button variant="secondary" fullWidth onClick={handleDeploy} data-id="element-1334" data-mp="m57805dorz71">
                <span className="inline-flex items-center justify-center gap-2" data-id="element-1335" data-mp="r41rl9jh9rs7">
                  <Zap size={16} strokeWidth={2.5} data-id="element-1336" data-mp="vv0746wn6lue" />
                  EXPRESS CHECKOUT
                </span>
              </Button>
              {(totalAddons > 0 || activeBundle) && <p className="font-inter text-[11px] text-text-dimmed text-center" data-id="element-1337" data-mp="14whveck7dtu6">
                  Includes {maskCount} mask{maskCount > 1 ? 's' : ''}
                  {activeBundle && ` (${activeBundle.name})`}
                  {totalAddons > 0 && ` + ${totalAddons} bonus lens${totalAddons > 1 ? 'es' : ''}`}
                </p>}
            </div>

            {/* Perks Grid */}
            {/* Perks Marquee — single-line infinite slider */}
            <div className="relative mb-10 border-y border-dark-3 bg-dark-1 overflow-hidden py-3" data-id="element-1338" data-mp="25232pg451wpq">
              <div className="absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-dark-1 to-transparent z-10 pointer-events-none" data-id="element-1339" data-mp="203i41l4jbl3e" />
              <div className="absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-dark-1 to-transparent z-10 pointer-events-none" data-id="element-1340" data-mp="17hghr0sm22wg" />
              <motion.div className="flex gap-8 whitespace-nowrap" animate={{
              x: ['0%', '-50%']
            }} transition={{
              duration: 10,
              ease: 'linear',
              repeat: Infinity
            }} data-id="element-1341" data-mp="1m74jg34pf3kp">
                {[...Array(2)].flatMap((_, dup) => [{
                icon: <Truck size={14} data-id="element-1342" data-mp="35499j9jrjj33" />,
                text: 'FREE USA SHIPPING'
              }, {
                icon: <Shield size={14} data-id="element-1343" data-mp="2qgeirypbfosn" />,
                text: 'LIFETIME WARRANTY'
              }, {
                icon: <RefreshCw size={14} data-id="element-1344" data-mp="2vc3hy0xfb3of" />,
                text: '30-DAY FREE RETURNS'
              }, {
                icon: <Lock size={14} data-id="element-1345" data-mp="3o22bo9mkbozf" />,
                text: '256-BIT SECURE CHECKOUT'
              }, {
                icon: <Check size={14} data-id="element-1346" data-mp="3a5oul1lxxplh" />,
                text: 'AMERICAN BRAND'
              }, {
                icon: <Check size={14} data-id="element-1347" data-mp="1ynxjjvr3h7il" />,
                text: 'VETERAN INSPECTED'
              }].map((perk, i) => <div key={`${dup}-${i}`} className="flex items-center gap-2 shrink-0 font-barlow font-bold text-[11px] tracking-[2px] text-text-body uppercase" data-id="element-1348" data-mp="22no4hitxwtf7" data-mpi={i}>
                      <span className="text-acid-green" data-id="element-1349" data-mp="34icuu09f7fx">{perk.icon}</span>
                      <span data-id="element-1350" data-mp="325n3uo9fssb">{perk.text}</span>
                      <span className="text-acid-green ml-6" data-id="element-1351" data-mp="82jvxexor6re">◆</span>
                    </div>))}
              </motion.div>
            </div>

            {/* Interactive Tabs — Specs / Fit / Shipping */}
            <div className="border border-dark-3 bg-dark-1" data-id="element-1352" data-mp="ztpwtxl8d8hq">
              {(() => {
              const tabs = [{
                id: 'specs',
                label: 'SPECS',
                sub: 'TECH'
              }, {
                id: 'fit',
                label: 'FIT',
                sub: 'SIZING'
              }, {
                id: 'shipping',
                label: 'SHIPPING',
                sub: 'POLICY'
              }];
              const activeTab = openAccordion || 'specs';
              return <>
                    {/* Tab triggers */}
                    <div className="grid grid-cols-3 border-b border-dark-3" data-id="element-1353" data-mp="3cyuyihjzfnu9">
                      {tabs.map(t => {
                    const isActive = activeTab === t.id;
                    return <button key={t.id} onClick={() => setOpenAccordion(t.id)} className={`relative px-3 py-3 text-center transition-colors ${isActive ? 'text-white bg-base-black' : 'text-text-dimmed hover:text-white'}`} data-id="element-1354" data-mp="2gb87x09lazoq">
                            <div className="font-barlow text-[9px] text-acid-green tracking-[2px] mb-0.5" data-id="element-1355" data-mp="21kr5bdl7y3q9">
                              {t.sub}
                            </div>
                            <div className="font-bebas text-[16px] tracking-[2px] leading-none" data-id="element-1356" data-mp="km7tn19ekp4">
                              {t.label}
                            </div>
                            {isActive && <motion.div layoutId="tab-indicator" className="absolute bottom-0 left-0 right-0 h-[2px] bg-acid-green" data-id="element-1357" data-mp="aaysdf92qdv9" />}
                          </button>;
                  })}
                    </div>

                    {/* Tab panel */}
                    <div className="p-5 min-h-[180px] relative" data-id="element-1358" data-mp="3nnqxxy87p63n">
                      <AnimatePresence mode="wait" data-id="element-1359" data-mp="3rqndth6dao3w">
                        <motion.div key={activeTab} initial={{
                      opacity: 0,
                      y: 8
                    }} animate={{
                      opacity: 1,
                      y: 0
                    }} exit={{
                      opacity: 0,
                      y: -8
                    }} transition={{
                      duration: 0.2
                    }} data-id="element-1360" data-mp="3rrgkki5btdm1">
                          {activeTab === 'specs' && <div className="grid grid-cols-2 gap-x-6 gap-y-2" data-id="element-1361" data-mp="28sr47yazk1bl">
                              {specs.map((s, i) => <div key={i} className="flex justify-between items-baseline border-b border-dark-3 py-1.5" data-id="element-1362" data-mp="1zqrnl73vuz96" data-mpi={i}>
                                  <span className="font-barlow text-[10px] text-acid-green tracking-[1.5px] uppercase" data-id="element-1363" data-mp="3u52cffkh9tey">
                                    {s.label}
                                  </span>
                                  <span className="font-inter text-[11px] text-white text-right" data-id="element-1364" data-mp="2lvv1otlwq4rs">
                                    {s.value}
                                  </span>
                                </div>)}
                              <div className="col-span-2 mt-2 flex items-center gap-2 pt-2 border-t border-acid-green/20" data-id="element-1365" data-mp="2cwgafrxx1q68">
                                <Check size={14} className="text-acid-green" data-id="element-1366" data-mp="233sibahvsadu" />
                                <span className="font-barlow text-[11px] text-acid-green tracking-[1px] uppercase" data-id="element-1367" data-mp="27v0qk37h5ppf">
                                  Includes Smoke Black Lenses (standard)
                                </span>
                              </div>
                            </div>}
                          {activeTab === 'fit' && <div className="space-y-4" data-id="element-1368" data-mp="1k7j7cw29zzy2">
                              <div className="flex items-center gap-3 mb-2" data-id="element-1369" data-mp="1p4sw09huc7ku">
                                <div className="font-bebas text-[40px] text-acid-green leading-none" data-id="element-1370" data-mp="15ihg5pcgry1f">
                                  52–62
                                </div>
                                <div data-id="element-1371" data-mp="10m0rmu1crhnt">
                                  <div className="font-barlow text-[10px] text-text-dimmed tracking-[2px] uppercase" data-id="element-1372" data-mp="1fh6ytkc6pmiq">
                                    Head Circumference
                                  </div>
                                  <div className="font-bebas text-[14px] text-white tracking-[1px]" data-id="element-1373" data-mp="1ogal0x6nei1g">
                                    CENTIMETERS
                                  </div>
                                </div>
                              </div>
                              {/* Fit range bar */}
                              <div className="relative h-2 bg-dark-3 w-full" data-id="element-1374" data-mp="1t8ty7t1fbb5q">
                                <div className="absolute inset-y-0 left-[5%] right-[5%] bg-gradient-to-r from-acid-green/60 to-acid-green" data-id="element-1375" data-mp="2794q8zegyvsh" />
                              </div>
                              <p className="font-inter text-[12px] text-text-dimmed leading-relaxed" data-id="element-1376" data-mp="2aa7w0w7841dz">
                                Universal fit. Dual-point reinforced nylon strap
                                + dense neoprene padding ensure secure,
                                zero-wobble wear on{' '}
                                <span className="text-white font-bold" data-id="element-1377" data-mp="2oyu88p1k0d0z">
                                  95% of adults and kids
                                </span>
                                .
                              </p>
                            </div>}
                          {activeTab === 'shipping' && <div className="space-y-3" data-id="element-1378" data-mp="32wiw85qx40a9">
                              {[{
                          icon: <Truck size={14} data-id="element-1379" data-mp="18kvoxjqua7cz" />,
                          label: 'SAME-DAY DISPATCH',
                          value: 'Orders before 2PM ET'
                        }, {
                          icon: <Check size={14} data-id="element-1380" data-mp="3qvtciffgb3pp" />,
                          label: 'FREE USA SHIPPING',
                          value: '3–5 day standard delivery'
                        }, {
                          icon: <RefreshCw size={14} data-id="element-1381" data-mp="3d3d2guo4u5fa" />,
                          label: '30-DAY RETURNS',
                          value: 'Prepaid label included'
                        }].map((item, i) => <div key={i} className="flex items-center gap-3 border-b border-dark-3 pb-2 last:border-b-0" data-id="element-1382" data-mp="4m8kwnrqq0at" data-mpi={i}>
                                  <div className="text-acid-green shrink-0" data-id="element-1383" data-mp="2pdr3o8bo9s7t">
                                    {item.icon}
                                  </div>
                                  <div className="flex-grow" data-id="element-1384" data-mp="oaro2ww690gf">
                                    <div className="font-barlow text-[10px] text-acid-green tracking-[2px] uppercase" data-id="element-1385" data-mp="o96upallfnk5">
                                      {item.label}
                                    </div>
                                    <div className="font-inter text-[11px] text-text-dimmed" data-id="element-1386" data-mp="eeeyob7nt8rh">
                                      {item.value}
                                    </div>
                                  </div>
                                </div>)}
                            </div>}
                        </motion.div>
                      </AnimatePresence>
                    </div>
                  </>;
            })()}
            </div>
          </div>
        </div>
      </div>
    </section>;
};